import type { WhatsNewEntry } from "../types";

/**
 * Release note: structured answers — 小环's answers take the right SHAPE (2026-06-28).
 * PRE-STAGED + flag-gated: committed here but shown only when FEATURE_IA_STRUCTURED_ANSWER
 * is on (WhatsNew filters by /healthz features.structuredAnswer). Value-level copy only —
 * no implementation detail (file names, architecture, "reads source code") in user copy.
 *
 * Uses the structured `sections` format (like code-qa / take-you-there) for the
 * premium launch-page hierarchy: a vision opener, the four deliverables as pillar
 * cards, then the "shape + provenance" beat and a closing line.
 */
export const structuredAnswers: WhatsNewEntry = {
  id: "2026-06-28-structured-answers",
  date: "2026-06-28",
  flag: "structuredAnswer",
  kicker: "发布说明",
  title: "答案,自成其形",
  subtitle: "Answers that draw themselves",
  video: "/whatsnew/structured-answers.mp4",
  summary:
    "答案不必只是一段话。你问什么，它就长成那件事该有的形状——能看、能发、能推进，还看得见从哪里来。",
  sections: [
    {
      kind: "lead",
      md: "文字，不该是答案的终点。\n\n它是答案开始成形的地方。"
    },
    {
      kind: "prose",
      md: "过去，问完一个问题，你得到一段话。\\\n然后真正的活才开始：读懂它，挑重点，改成能讲、能发、能推进的样子。\n\n现在，这件事反过来——答案不必只是一段话。"
    },
    {
      kind: "pillars",
      eyebrow: "See it. Don't just read it.",
      heading: "答案，长成该有的样子",
      items: [
        { icon: "grid", title: "一件牵扯很多的事", desc: "一张一眼看懂的全景图，拿去对齐、直接开讲。" },
        { icon: "chart", title: "一个需要说服人的场合", desc: "一张能直接发出去的「前 vs 后」。" },
        { icon: "branch", title: "一处卡住的问题", desc: "一条按可能性排好的排查路径。" },
        { icon: "file", title: "一段要对外讲的话", desc: "一个可以直接拿去用的版本。" }
      ]
    },
    {
      kind: "prose",
      md: "答案开始有自己的形状。\\\n该展开的地方，它展开；\\\n该对比的地方，它对比；\\\n该落到行动的地方，它给你下一步。\n\n也看得见它从哪里来。\\\n关键结论能点开来源，重要判断能回到依据。\\\n没有找到证据的地方，它不会装作确定。"
    },
    {
      kind: "quote",
      md: "答案的形状，会越来越贴近你要完成的事。\\\n从今天起，答案开始自成其形。"
    }
  ]
};
